module.exports = __webpack_public_path__ + "fonts/Roboto-400-cyrillic2.5e49381.woff2";